<template>
  <div class="d-flex-row space-between align-start lg-row-to-col top_footer">
    <!-- BM -->
    <div
      class="d-flex-column brand_container justify-start align-start justify-md-center align-md-center gap-30 flex-3"
    >
      <img
        src="/images/footer_logo.webp"
        loading="lazy"
        alt="Boostingmarket.com Logo"
        height="110"
        width="157"
        class="footer_logo"
      />
      <div class="d-flex-row justify-start justify-md-center align-md-center">
        <!-- <FooterDiscord /> -->
        <a
          href="https://instagram.com/boostingmarketofficial"
          target="_blank"
          referrerpolicy="no-referrer"
        >
          <FooterInsta />
        </a>
        <a
          href="https://www.facebook.com/boostingmarket/"
          target="_blank"
          referrerpolicy="no-referrer"
        >
          <FooterFacebook />
        </a>
        <a
          href="https://www.tiktok.com/@boostingmarket"
          target="_blank"
          referrerpolicy="no-referrer"
        >
          <FooterTiktok />
        </a>
        <a
          href="https://x.com/BoostingMarket"
          target="_blank"
          referrerpolicy="no-referrer"
        >
          <FooterX />
        </a>
        <!-- <FooterTwitter /> -->
      </div>
      <p class="t-grey-dark font-family-2 regular-s" style="width: 40ch">
        {{ $t("main.footer.legal") }}
      </p>
    </div>
    <!-- MAIN/CONTACTS -->
    <div class="d-flex-row space-between align-start flex-4 main_container_2">
      <div
        class="d-flex-column main_container_main justify-start align-start gap-30 flex-5"
      >
        <p class="t-white title-h6 font-family-1 f-w-600">
          {{ $t("main.footer.main") }}
        </p>
        <div class="d-flex-column justify-start align-start gap-10">
          <NuxtLinkLocale
            class="t-grey regular-l dark tab_plain _orange font-family-2 footer-link"
            :to="'/'"
            active-class="active_tab"
          >
            {{ $t("main.footer.home") }}
          </NuxtLinkLocale>

          <NuxtLinkLocale
            class="t-grey regular-l dark tab_plain _orange font-family-2 footer-link"
            :to="'/membership'"
            active-class="active_tab"
          >
            {{ $t("main.footer.membership") }}
          </NuxtLinkLocale>

          <NuxtLinkLocale
            class="t-grey regular-l dark tab_plain _orange font-family-2 footer-link"
            :to="'/blogs'"
            active-class="active_tab"
          >
            {{ $t("main.nav.blogs") }}
          </NuxtLinkLocale>
        </div>
      </div>

      <div
        class="d-flex-row contact_container space-between align-start gap-30 flex-5 flex-wrap"
      >
        <div class="d-flex-column justify-start align-start gap-30 flex-3">
          <p class="t-white title-h6 font-family-1 f-w-600">
            {{ $t("help") }}
          </p>
          <div class="d-flex-column justify-start align-start gap-10">
            <NuxtLinkLocale
              class="t-grey regular-l dark tab_plain _orange font-family-2 footer-link"
              :to="'/contact'"
              active-class="active_tab"
            >
              {{ $t("contact.contact_us") }}
            </NuxtLinkLocale>

            <NuxtLinkLocale
              class="t-grey regular-l dark tab_plain white-space-no _orange font-family-2 footer-link"
              :to="'/work-with-us'"
              active-class="active_tab"
            >
              {{ $t("main.nav.work_with_us") }}
            </NuxtLinkLocale>
          </div>
        </div>
      </div>
    </div>
    <div class="payment_method_container_grid contact_container flex-3">
      <div class="payment_pill" v-for="payment in payments" :key="payment">
        <img
          :src="payment"
          loading="lazy"
          alt="Payment pill"
          class="payment_pill_image"
          height="26"
          width="143"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import FooterInsta from "~/components/icons/socials/FooterInsta.vue";
import FooterFacebook from "~/components/icons/socials/FooterFacebook.vue";
import FooterTiktok from "~/components/icons/socials/FooterTiktok.vue";
import FooterX from "~/components/icons/socials/FooterX.vue";
import { ref } from "vue";
const { openChat } = useCrispComposable();
const open = () => {
  openChat();
};
const payments = ref([
  "/images/payments/stripe-pill.svg",
  "/images/payments/coinbase-pill.svg",
  "/images/payments/skrill-pill.svg",
  "/images/payments/paypal-pill.svg",
  "/images/payments/paysafe-pill.svg",
  "/images/payments/gpay-pill.svg",
]);
</script>
